import { Component, signal } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';

@Component({
  selector: 'app-icon',
  standalone: false,
  templateUrl: './icon.component.html',
  styleUrl: './icon.component.scss',
})
export class IconComponent implements ICellRendererAngularComp {
  readonly mdiIcon = signal<string>('help');
  readonly tooltip = signal<string>('');

  agInit(params: ICellRendererParams): void {
    this.refresh(params);
  }
  refresh(params: ICellRendererParams): boolean {
    if (!!params.value) this.mdiIcon.set(params.value);

    const tooltipField = params.colDef?.cellRendererParams['tooltip'];
    if (!!tooltipField) {
      this.tooltip.set(params.data[tooltipField]);
    }
    return true;
  }
}
